import CloseIcon from "@material-ui/icons/Close";
import { Box, IconButton, Modal, Typography } from "@mui/material";
import CheckoutPage from "components/PaymentComponents/CheckoutPage";
import { useEffect, useState } from "react";
import CourseSetupWizard from "./CourseSetupWizard";

const BuyNowPopup = ({ open, onClose, plan }) => {
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({});
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [providerId, setProviderId] = useState(null);
    const [user, setUser] = useState(null);
    useEffect(() => {
        if (!open) {
            setStep(1);
            setFormData({});
            setUser(null);
        }
    }, [open]);

    const validate = () => {
        if (!formData.name || !formData.email || !formData.mobile) {
            alert("Please fill all required fields");
            return false;
        }
        return true;
    };

    const next = (data) => {
        setFormData((prev) => ({ ...prev, ...data }));
        setStep(2);
    };
    console.log(plan, '-plann')
    // FINAL SUBMIT WITH API
    const submit = async (courseData) => {
        onClose();
    };


    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: { xs: "90%", sm: "70%", md: "50%" },
                    maxHeight: "90vh",
                    overflowY: "auto",
                    bgcolor: "#fff",
                    borderRadius: 2,
                    p: 3,
                    boxShadow: 24,
                }}
            >
                <IconButton
                    onClick={onClose}
                    sx={{ position: "absolute", top: 8, right: 8 }}
                >
                    <CloseIcon />
                </IconButton>
                <Typography sx={{ textTransform: 'capitalize' }} variant="h6" mb={2}>
                    {step === 1 ? "Information" : "Course Setup"}
                </Typography>
                {step === 1 && <Typography>
                    {plan?.title}
                    {/* <span style={{ fontWeight: 'bold', color: '#f59f0a' }}>₹&nbsp;{plan?.price}</span> */}
                </Typography>}

                {/* <Typography variant="h6" mb={2}>
                    {step === 1 && "Your Details"}
                    {step === 2 && "Select Program Template"}
                    {step === 3 && "Course Setup"}
                </Typography> */}

                {step === 1 && (
                    <CheckoutPage
                        plan={plan}
                        onUserSet={setUser}
                        onPaymentSuccess={(providerId) => {
                            setProviderId(providerId);
                            setStep(2);
                        }}

                    />
                )}

                {step === 2 && (
                    <CourseSetupWizard
                        onSubmit={submit}
                        providerId={providerId}
                        userData={user}
                    />
                )}

            </Box>
        </Modal>
    );
};

export default BuyNowPopup;
